module.exports = __webpack_public_path__ + "media/images/locations/circle/losangels-04468dcdc974e117009f34c8f986629e.jpg";